import type { JSX } from 'react';
import { useState, useRef, useCallback, useEffect } from 'react';
import './QuitButton.css';

export default function QuitButton(): JSX.Element {
  const [pos, setPos]      = useState({ x: 0, y: 0 });
  const [fleeing, setFlee] = useState(false);
  const btnRef             = useRef<HTMLButtonElement>(null);
  const timerRef           = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const flee = useCallback((e: React.MouseEvent): void => {
    if (!btnRef.current) return;
    const r     = btnRef.current.getBoundingClientRect();
    const dx    = (r.left + r.width / 2)  - e.clientX;
    const dy    = (r.top  + r.height / 2) - e.clientY;
    const angle = Math.atan2(dy, dx) + (Math.random() - 0.5) * 1.2;
    const speed = 170 + Math.random() * 80;
    setPos({ x: Math.cos(angle) * speed, y: Math.sin(angle) * speed });
    setFlee(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setPos({ x: 0, y: 0 });
      setFlee(false);
    }, 2400);
  }, []);

  return (
    <div className="QuitButton__wrap">
      <button
        ref={btnRef}
        className={`QuitButton${fleeing ? ' QuitButton--fleeing' : ''}`}
        style={{ transform: `translate(${String(pos.x)}px, ${String(pos.y)}px)` }}
        onMouseEnter={flee}
        tabIndex={-1}
        aria-label="Quitter le site (bonne chance)"
      >
        Quitter le site
      </button>
      <p className="QuitButton__sub">
        {fleeing ? 'Pas si vite...' : 'Tu peux partir quand tu veux.'}
      </p>
    </div>
  );
}
